import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { VeldaLanguage } from 'src/app/models/VeldaLanuage';

import { DeleteLanguage } from '../velda-languages.actions';

@Component({
    selector: 'app-velda-languages-languages-delete-modal',
    templateUrl: './velda-languages-languages-delete-modal.component.html',
    styleUrls: ['./velda-languages-languages-delete-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VeldaLanguagesLanguagesDeleteModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() language: VeldaLanguage;

    constructor(private store: Store, public activeModal: NgbActiveModal, private toastrService: ToastrService, private logger: NGXLogger) {}

    ngOnInit(): void {}

    deleteLanguage() {
        this.logger.debug('Attempt to delete language');

        this.subscriptions.add(
            this.store.dispatch(new DeleteLanguage(this.language.uuid)).subscribe(
                () => {
                    this.toastrService.success('Language deleted successfully!');
                    this.logger.debug('Language delete successfully!');
                    this.activeModal.close();
                },
                (error) => {
                    this.toastrService.error('Failed to delete language!');
                    this.logger.error('Failed to delete language!');
                },
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
